import {
  SET_ACCEPTED_POLICIES,
  ADD_ACCEPTED_POLICY,
  UPDATE_ACCEPTED_POLICY
} from "./ActionTypes";

/**
 * Save ALL accepted policies (from backend)
 */
export const setAcceptedPolicies = (policies) => ({
  type: SET_ACCEPTED_POLICIES,
  payload: policies,
});

/**
 * Add ONE accepted policy
 */
export const addAcceptedPolicy = (policy) => ({
  type: ADD_ACCEPTED_POLICY,
  payload: policy,
});

export const updateAcceptedPolicy = (policy) => ({
  type: UPDATE_ACCEPTED_POLICY,
  payload: policy,
});
